import type { RootState } from '@/store/root-reducer';

const selectEditFundraising = (state: RootState) => state.editFundraising;

export const selectFundraising = (state: RootState) => selectEditFundraising(state).fundraising;
export const selectDraft = (state: RootState) => selectEditFundraising(state).draft;
export const selectLoadStatus = (state: RootState) => selectEditFundraising(state).loadStatus;
export const selectSaveStatus = (state: RootState) => selectEditFundraising(state).saveStatus;
export const selectError = (state: RootState) => selectEditFundraising(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectEditFundraising(state).validationErrors;

export const selectIsSaving = (state: RootState) =>
  selectEditFundraising(state).saveStatus === 'saving';
export const selectLoadFailed = (state: RootState) =>
  selectEditFundraising(state).loadStatus === 'failed';
export const selectDeleteStatus = (state: RootState) => selectEditFundraising(state).deleteStatus;
export const selectDeleteError = (state: RootState) => selectEditFundraising(state).deleteError;
export const selectRevertStatus = (state: RootState) => selectEditFundraising(state).revertStatus;
